import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'formly-field-tabs',
    template: `
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedIndex">
      @for (tab of field.fieldGroup; track tab.id ?? i; let i = $index; let last = $last) {
      <mat-tab 
        [label]="tab.props.label" [attr.data-test] = "'tab-'+ i"
      >
        <formly-field [field]="tab"></formly-field>

        <div class="d-flex justify-content-center align-items-center buttons">
            @if ((field.fieldGroup?.length - 1) !== selectedIndex) {
            <button mat-raised-button [ngClass]="field.props.isPublicForm ? 'btn btn-primary' : 'context-button'" mat-raised-button color="primary"
              type="button" (click)="moveToNextTab()">
              {{ 'BUTTON.NEXT' | translate }}
              <mat-icon style="width: 16px;">chevron_right</mat-icon>
            </button>
            }
            @if ((field.fieldGroup?.length - 1) === selectedIndex) {
            <button mat-raised-button [ngClass]="field.props.isPublicForm ? 'btn btn-primary' : 'context-button'" [disabled]="field.props.submitting"
              mat-raised-button color="primary" type="submit">{{ 'BUTTON.SUBMIT' | translate }}</button>
            }
            @if (field.props.isPublicForm) {
            <button mat-button class="btn" [disabled]="field.props.submitting"
              type="button" (click)="options.resetModel()">{{ 'BUTTON.CLEAR' | translate }}</button>
            }
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  `,
    styleUrls: ['./tabs-type.component.scss'],
    imports: [MatTabGroup, MatTab, FormlyModule, MatButton, NgClass, MatIcon, TranslateModule]
})

export class FormlyFieldTabs extends FieldType {
  
  selectedIndex = 0;
  
  moveToNextTab(): void {
    this.selectedIndex = this.selectedIndex + 1;
  }

}